export class File {
  public constructor(public id: number, public path: string) {}
}
